export default "__VITE_ASSET__CkraGIM6__"